import ReceiptIcon from "./ReceiptIcon";

const plate = (vehicle) => [vehicle?.plate1, vehicle?.plate2, vehicle?.plate3, vehicle?.plateEnd].filter(Boolean).join(" ") || "پلاک ثبت نشده";
const customerName = (customer) => [customer?.firstName, customer?.lastName].filter(Boolean).join(" ") || "مشتری";

export default function ReceiptVehicle({ vehicle, customer, mileage }) {
  return <section className="receipt-vehicle">
    <header><span><ReceiptIcon name="car" /></span><div><small>خودروی سرویس‌شده</small><h2>{vehicle?.title || vehicle?.brand || "خودرو"}</h2></div><b>{plate(vehicle)}</b></header>
    <div className="receipt-vehicle__meta"><span><ReceiptIcon name="user" /><small>مشتری</small><b>{customerName(customer)}</b></span><span><ReceiptIcon name="speed" /><small>کیلومتر</small><b>{Number(mileage || 0).toLocaleString("fa-IR")}</b></span></div>
  </section>;
}
